import React from 'react'
import { graphql } from 'gatsby'
import { filterArrayByType } from '../utility.js'
import { linkResolver } from '../linkResolver.js'
import CampExperience from '../components/camp-experience/camp-experience'
import Layout from '../components/layout/layout'
import { Seo } from '../components/seo-copy'
import TitleBar from '../components/titlebar-landing/titlebar-landing.js'
import Hero from '../components/hero-landing/hero-landing'
import SectionBlock from '../components/section-block'
import Columns from '../components/columns'
import Banner from '../components/banner'
import CardLanding from '../components/card-landing'
import CallOutBlock from '../components/call-out/call-out-block'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'

const LandingTemplate = ({ props, data, location }) => {
  const meta = data?.allPrismicLandingPageHeroBlock?.nodes[0]
  const doc = data?.allPrismicLandingPageHeroBlock?.nodes[0]?.data

  const {
    wide_header_size,
    title,
    feature,
    summary,
    summary_rich_text,
    cta,
    button_label,
    meta_title,
    meta_description,
    body,
  } = doc

  // console.log('LANDING Doc -->', doc)
  if (!doc) return null

  let featuredItems = filterArrayByType(body, 'feature_block').pop()

  featuredItems =
    typeof featuredItems !== 'undefined' ? featuredItems.items : null

  let campBlocks = filterArrayByType(body, 'camp_feature_callout').pop()
  campBlocks = typeof campBlocks !== 'undefined' ? campBlocks.items : null

  let section
  if (meta.tags.includes('Get Involved')) {
    section = 'support-us'
  } else if (meta.tags.includes('Animals')) {
    section = 'animals'
  }

  return (
    <Layout title={title.text} section={section} {...props}>
      
      <Hero image={wide_header_size} pageId={meta.id} />
      <TitleBar
        title={title.text}
        link={cta}
        linkText={button_label}
        description={summary}
        richDescription={summary_rich_text.richText}
        calloutDescription={feature.richText.length > 0 && feature.richText}
      />
      {featuredItems &&
        featuredItems.map((d, i) => {
          return (
            <SectionBlock key={i}>
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <CardLanding
                      color={d.color_name}
                      image={d.callout_image?.url}
                      season=""
                      year=""
                      minAge=""
                      maxAge=""
                      title={d.callout_title}
                      description={d.callout_description?.text}
                      urlText={d.cta_text}
                      link={linkResolver(d.cta)}
                    />
                  </div>
                </div>
              </div>
            </SectionBlock>
          )
        })}
      {campBlocks &&
        campBlocks.map((d, i) => {
          return (
            <SectionBlock key={i}>
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <CampExperience
                      color={d.color_name}
                      image={d.callout_image}
                      title={d.callout_title}
                      richDescription={d.description}
                      ageRange={d.age_range}
                      startDate={d.date_start}
                      endDate={d.date_end}
                      timeRange={d.time_range}
                      prices={[
                        {
                          price: d.reg_plu_price,
                          description: d.reg_plu_price_description,
                        },
                        {
                          price: d.fotz_plu_price,
                          description: d.fotz_plu_price_description,
                        },
                      ]}
                      btnText={d.cta_label}
                      url={linkResolver(d.cta)}
                    />
                  </div>
                </div>
              </div>
            </SectionBlock>
          )
        })}
      <Columns body={body} />
      <CallOutBlock body={body} />
      <Banner body={body} />
    </Layout>
  )
}

export default withPrismicPreview(LandingTemplate)

export const Head = ({ data, location }) => (
  <Seo
    title={data?.allPrismicLandingPageHeroBlock?.nodes[0]?.data?.meta_title}
    description={data?.allPrismicLandingPageHeroBlock?.nodes[0]?.data?.meta_description
    }
    pathname={location.pathname}
  />
)

export const query = graphql`
  query LandingTemplateQuery($uid: String) {
    allPrismicLandingPageHeroBlock(filter: { uid: { eq: $uid } }) {
      nodes {
        _previewable
        id
        uid
        type
        tags
        data {
          meta_title
          meta_description
          wide_header_size {
            alt
            url
          }
          title {
            richText
            text
          }
          summary,
          summary_rich_text {
            richText
          }
          feature {
            richText
            text
          }
          button_label
          cta {
            link_type
            url
          }
          body {
            ... on PrismicLandingPageHeroBlockDataBodyFeatureBlock {
              id
              slice_type
              slice_label
              items {
                color_name
                callout_description {
                  richText
                  text
                }
                callout_image {
                  alt
                  url
                }
                callout_title
                cta_text
                cta: cta1 {
                  link_type
                  url
                  id
                  uid
                  type
                  tags
                }
              }
            }
            ... on PrismicLandingPageHeroBlockDataBodyDetailedCallout {
              id
              slice_type
              slice_label
              items {
                title: title1 {
                  richText
                  text
                }
                text: text1 {
                  richText
                  text
                }
                image: image1 {
                  alt
                  url
                }
                image_type
                color
                cta_label
                cta: link {
                  link_type
                  url
                  id
                  uid
                  type
                  tags
                }
              }
            }
            ... on PrismicLandingPageHeroBlockDataBodyDonationColumns {
              id
              slice_type
              slice_label
              items {
                color
                column_image {
                  alt
                  url
                }
                column_text {
                  richText
                  text
                }
                column_title {
                  richText
                  text
                }
                cta_label
                cta_link {
                  link_type
                  url
                  document {
                    ... on PrismicDetail {
                      id
                      uid
                      type
                      tags
                    }
                  }
                }
              }
            }
            ... on PrismicLandingPageHeroBlockDataBodyBanner {
              id
              slice_type
              slice_label
              items {
                banner_color
                icon
                title1
                text {
                  richText
                  text
                }
              }
            }
            ... on PrismicLandingPageHeroBlockDataBodyCampFeatureCallout {
              id
              slice_type
              items {
                age_range
                callout_image {
                  alt
                  url
                }
                callout_title
                color_name
                cta_label
                description
                fotz_plu_price
                fotz_plu_price_description
                reg_plu_price
                reg_plu_price_description
                time_range {
                  richText
                  text
                }
                cta {
                  link_type
                  document {
                    ... on PrismicCamp {
                      id
                      uid
                      type
                      tags
                    }
                    ... on PrismicDetail {
                      id
                      uid
                      type
                      tags
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
